import  HeathsStory from './HeathsStory';
const __HeathsStory = HeathsStory;
export { __HeathsStory as HeathsStory };
export default HeathsStory;